<div *ngIf="!hideUpload">
  <div class="upload-wrapper">
    <p-fileUpload *ngIf="editable" #fileUpload
                  chooseLabel="{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.UPLOAD_FILE' | translate }}"
                  [accept]="accept"
                  customUpload="true" mode="basic" auto="true"
                  (uploadHandler)="onSelect($event)"
                  [multiple]="multiple"
                  (onSelect)="fileTypeValidation($event)">
    </p-fileUpload>
  </div>

  <ng-content *ngIf="editable"></ng-content>
</div>

<ul class="loaded-attachments">
  <li *ngFor="let file of filteredFiles() | slice:0:maxFiles" class="m-b-5">
    <a class="fa fa-download download-attachment"
       (click)="downloadSelectedFile(file)"
       pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.DOWNLOAD' | translate}}"
       tooltipPosition="bottom">
    </a>
    <a (click)="downloadSelectedFile(file)" class="m-r-5 attachment">
      <span *ngIf="fileName" tooltipPosition="top" pTooltip="{{ file.fileName }}">
        {{ file | fileInfoName:fileName }}
      </span>
      <span *ngIf="!fileName">
        {{ file.fileName }}
      </span>
    </a>
    <a class="fa fa-trash delete-attachment"
       (click)="removeArea(file)"
       pTooltip="{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.REMOVE' | translate}}"
       tooltipPosition="bottom">
    </a>
  </li>
</ul>

<a class="pointer"
   *ngIf="filteredFiles().length > maxFiles"
   (click)="maxFiles = 999">
  show older
</a>
